<!--
 * @Description: 跟进记录
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-11-23 18:41:36
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        v-model:search="searchFrom"
        @fetch="fetch"
        ref="tableRef"
        tableId="lbufollowUpRecord"
      >
        <template #search>
          <a-form :model="searchFrom">
            <dc-form-item name="customerName" label="客户名称" :span="12">
              <a-textarea
                v-model:value="searchFrom.customerName"
                :autoSize="{ minRows: 1, maxRows: 4 }"
                placeholder="请输入"
              />
            </dc-form-item>
            <dc-form-item name="tmsCode" label="客户代码" :span="12">
              <a-textarea
                v-model:value="searchFrom.tmsCode"
                :autoSize="{ minRows: 1, maxRows: 4 }"
                placeholder="请输入"
              />
            </dc-form-item>
            <dc-form-item name="mode" label="跟进方式">
              <ParamCodesSelect
                v-model:value="searchFrom.modeList"
                :options="paramCodeData.lbu_follow_mode"
                placeholder="请选择"
                mode="multiple"
                allowClear
              />
            </dc-form-item>
            <dc-form-item name="dutyBy" label="客户负责人">
              <UserSelect permission v-model:value="searchFrom.dutyByList" mode="multiple" />
            </dc-form-item>
            <dc-form-item name="updateByList" label="更新人">
              <UserSelect permission v-model:value="searchFrom.updateByList" mode="multiple" />
            </dc-form-item>
            <dc-form-item name="mobile" label="手机号">
              <a-input v-model:value="searchFrom.mobile" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="客户区域">
              <CustomerAreaCascader type="search" appId="cos_lbu" v-model:ids="searchFrom.customerAreaList" />
            </dc-form-item>
            <dc-form-item label="员工区域">
              <CustomerAreaCascader type="search" appId="cos_lbu" v-model:ids="searchFrom.employeeRegionList" />
            </dc-form-item>
            <dc-form-item label="时间筛选">
              <a-input-group compact>
                <a-select v-model:value="searchFrom.timeType" style="width: 33%">
                  <a-select-option :value="0">创建时间</a-select-option>
                  <a-select-option :value="1">跟进时间</a-select-option>
                  <a-select-option :value="2">更新时间</a-select-option>
                </a-select>
                <CosRangePicker
                  v-model:startTime="searchFrom.startTime"
                  v-model:endTime="searchFrom.endTime"
                  style="width: 67%"
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item name="followRefId" label="客户ID">
              <a-input v-model:value="searchFrom.followRefId" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="contactName" label="联系人姓名">
              <a-input v-model:value="searchFrom.contactName" placeholder="请输入" />
            </dc-form-item>
          </a-form>
        </template>
        <template #button>
          <a-button type="primary" @click="handleAdd" v-permission="'lbu_follow_add_btn'"> 写跟进 </a-button>
          <ExportButton
            appId="cos_lbu"
            taskType="306"
            :search="customerListFormat(searchFrom)"
            :totalCount="totalCount"
            v-permission="'lbu_follow_export_btn'"
            >导出</ExportButton
          >
        </template>
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'startTime'">
            <p>{{ text }}~{{ record.endTime }}</p>
          </template>
          <template v-if="column.dataIndex === 'process'">
            <p v-html="xss(text)"></p>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <MoreButton>
              <a-button
                type="link"
                @click="handleEdit(record)"
                v-permission="'lbu_follow_edit_btn'"
              >
                编辑
              </a-button>
              <a-button type="link" @click="deleteRow(record)" v-permission="'lbu_follow_del_btn'"> 删除 </a-button>
              <a-button type="link" @click="handleCommit(record)" v-permission="'lbu_follow_comment_btn'">
                评论
              </a-button>
            </MoreButton>
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script setup lang="ts">
import { ref, computed, reactive, onMounted } from 'vue'
import { message } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import CosRangePicker from '@/components/CosRangePicker/index'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { LbuFollowUpRecordParams, LbuFollowUpRecordItem } from '@/typings/api/followUpManage'
import { lbuFollowRecordsList, followRecordsDelete } from '@/api/yuntuSales/followUpManage'
import { clueAndcustomerPhaseEnum, customerAllStatusEnum } from '@/views/yuntuSales/commonEnum/dataConfig'
import { useRouter } from 'vue-router'
import xss from 'xss'
import { listByParamCodes } from '@/api/common'
import { customerListFormat } from '@/utils'
const tableRef = ref()
const router = useRouter()
const searchFrom = ref<LbuFollowUpRecordParams>({
  timeType: 0
})
const totalCount = ref(0)

const paramCodeData = reactive<{
  lbu_follow_mode: []
  lbu_follow_purpose: []
}>({
  lbu_follow_mode: [], // 拜访方式
  lbu_follow_purpose: [] // 访客目的
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_follow_mode', 'lbu_follow_purpose']
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
const columns = computed(() => [
  { title: '主账号代码', dataIndex: 'customerNumber', fixed: 'left' },
  { title: '客户代码', dataIndex: 'tmsCode', fixed: 'left' },
  {
    title: '客户名称',
    dataIndex: 'customerName',
    cosType: 'link',
    path: '/lbu/followUpRecord/view',
    query: ['id'],
    fixed: 'left',
    width: 200
  },
  { title: '客户ID', dataIndex: 'followRefId', width: 200 },
  { title: '客户阶段', dataIndex: 'stage', dicData: clueAndcustomerPhaseEnum },
  { title: '跟进状态', dataIndex: 'followStatus', dicData: customerAllStatusEnum },
  { title: '跟进方式', dataIndex: 'mode', dicData: paramCodeData.lbu_follow_mode },
  { title: '跟进时间', dataIndex: 'startTime', width: 350, sorter: true },
  { title: '联系人姓名', dataIndex: 'contactName' },
  { title: '目的', dataIndex: 'lbuPurpose', width: 200 },
  { title: '跟进过程', dataIndex: 'process', width: 200 },
  { title: '结果/后续', dataIndex: 'result', width: 200 },
  { title: '当前遇到的问题', dataIndex: 'problem', width: 200 },
  { title: '客户负责人', dataIndex: 'dutyByName' },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime', width: 190, sorter: true },
  { title: '更新人', dataIndex: 'updateByName' },
  { title: '更新时间', dataIndex: 'updateTime', width: 190, sorter: true },
  { title: '操作', dataIndex: 'action', fixed: 'right', width: 150 }
])
const fetch = (params: LbuFollowUpRecordParams, callBack: (res: any) => void) => {
  const queryForm = customerListFormat(params) // 处理客户名称和客户编码的批量查询参数

  const followRefId = queryForm.followRefId
  if (followRefId !== undefined && followRefId.length > 0) {
    queryForm.followRefIdList = followRefId.split(' ')
    queryForm.followRefId = undefined
  }

  lbuFollowRecordsList(queryForm).then((res) => {
    totalCount.value = res?.data?.totalCount || 0
    callBack(res)
  })
}

const handleAdd = () => {
  router.push({
    path: '/lbu/followUpRecord/add'
  })
}
const handleEdit = (record: LbuFollowUpRecordItem) => {
  router.push({
    path: '/lbu/followUpRecord/edit',
    query: {
      id: record.id
    }
  })
}
const handleCommit = (record: LbuFollowUpRecordItem) => {
  router.push({
    path: '/lbu/followUpRecord/commit',
    query: {
      id: record.id
    }
  })
}
const deleteRow = (record: LbuFollowUpRecordItem) => {
  Modal.delete({
    onOk() {
      followRecordsDelete(record.id).then(() => {
        message.success('删除成功')
        success()
      })
    }
  })
}
const success = (type = 'edit') => {
  if (type === 'add') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
onMounted(() => {
  getByParamCodes()
})
</script>
<script lang="ts">
export default {
  name: 'DcCosLbuFollowUpRecord'
}
</script>
